import Alert from "@mui/material/Alert";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { type ComponentType } from "react";
import { Question } from "../Icons";
import { BodyTextM, HeadingM } from "../Typography";
import { OverviewBase } from "../Overview";

const OverviewBaseStyled = OverviewBase as ComponentType<any>;

export const HelpOverview = styled(OverviewBaseStyled, {
    shouldForwardProp: (prop) => prop !== "noImage",
})<{ noImage: boolean }>(({ theme, noImage }) =>
    theme.unstable_sx({
        backgroundColor: "transparent",
        flexGrow: { md: noImage ? 0 : 1 },
        width: { md: noImage ? "100%" : "57.5%", xs: "100%" },
        "&.MuiCard-root": {
            alignSelf: "center",
            px: { md: noImage ? 0 : 4, xs: 0 },
        },
        ".MuiCardMedia-root": {
            pb: { md: noImage ? 0 : "174px", xs: 0 },
            backgroundPosition: "bottom center",
            backgroundSize: "338px",
        },
    }),
);

export const HelpAlert = styled(Alert)(({ theme }) =>
    theme.unstable_sx({
        py: 3,
        px: 4,
        border: "1px solid",
        borderColor: "grey.light",
        backgroundColor: "white.main",
        flexDirection: "row-reverse",
        boxShadow: "far",
        ".MuiAlert-icon": {
            mr: 0,
            ml: 4,
        },
        ".MuiAlert-message": {
            flexGrow: 1,
        },
    }),
);

export const HelpIcon = styled(Question)({
    width: 32,
    height: 32,
});

export const HelpHeading = styled(HeadingM)(({ theme }) =>
    theme.unstable_sx({
        display: "inline-block",
        mb: 3,
    }),
);

export const HelpBodyText = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        mb: 2,
    }),
);

export const SmartActionsRow = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        width: "100%",
        flexDirection: "row",
        justifyContent: "center",
        gap: 4,
    }),
);

export const SmartActionSkeleton = styled(Skeleton)(({ theme }) =>
    theme.unstable_sx({
        width: "33.33%",
        height: { md: 92, xs: 74 },
        bgcolor: "primary.main",
    }),
);

export const QuestionnaireSkeletonRow = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        mt: 3,
        flexDirection: "row",
    }),
);

export const QuestionnaireSkeleton = styled(Skeleton)(({ theme }) =>
    theme.unstable_sx({
        width: "100%",
        height: 60,
        bgcolor: "primary.main",
    }),
);

export const SmartActionsPanelColumn = styled(Stack)({
    flexDirection: "column",
});

export const SmartActionsContentRow = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        justifyContent: "center",
        gap: 3,
    }),
);

export const SmartActionsQuestionnaireWrapper = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        mt: 3,
    }),
);

export const SmartActionsWarningsColumn = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "column",
        gap: 2,
    }),
);
